import React from 'react';
import { Card, Collapse, Table } from 'antd';
import CopyToClipboard from 'react-copy-to-clipboard';
import { CopyOutlined } from '@ant-design/icons';
import { ShippingRoute } from '../../../utils/types';
import message from '../../../components/message';

const columns = [
  {
    title: '重量',
    dataIndex: 'startWeight',
    render: (startWeight) => `${startWeight}kg 起`,
  },
  {
    title: '收费',
    dataIndex: 'unitPrice',
    render: (unitPrice, record) => record.basePrice === 0 ? `￥${unitPrice}/kg` : `￥${record.basePrice}+￥${unitPrice}/kg`,
  },
  // {
  //   title: '取整单位',
  //   dataIndex: 'roundingWeight',
  //   render: (text) => `${text}kg`,
  // },
];

const routeCard = ({ route, isGroup }: { route: ShippingRoute, isGroup: boolean }) => {
  const priceRanges = route.priceRanges.map((range, index) => ({...range, index}));
  return (
    <Card
      className="RouteCard"
      title={
        <div>
          {route.name}
          <CopyToClipboard
            text={route.name}
            onCopy={() => {
              message.success('线路名已复制');
            }}
          >
            <span style={{ color: '#666' }}>
              &nbsp;&nbsp;&nbsp;
              <CopyOutlined />
            </span>
          </CopyToClipboard>
        </div>
      }
      bordered={false}
      extra={[
        (<span key="method">{route.shippingMethod === 'SEA' ? '海运' : '空运'}</span>)
      ]}
    >
      <div className="RouteContent">
        <div style={{ wordBreak: 'break-all' }}>
          {route.notes &&
            <p>线路须知：{route.notes}</p>
          }
          <p>正常时效：发货后约{route.speed}</p>
          {route.dimensionalFactor ? (
            <p>
              体积重计算(kg)：长(cm)&times;宽(cm)&times;高(cm)/{route.dimensionalFactor}
            </p>
          ) : (
            <p>体积重：该渠道通常不收取体积重费用</p>
          )}

          {isGroup && (
            <p>单人最低消费重量：{route.groupIndividualMinWeight}kg</p>
          )}

          {isGroup && (
            <p>最低拼团重量：{route.groupMinWeight}kg</p>
          )}

          <Table
            dataSource={priceRanges}
            rowKey="index"
            size="small"
            columns={columns}
            pagination={false}
          />

          <Collapse ghost expandIconPosition="right" style={{ marginTop: '5px' }}>
            <Collapse.Panel key="1" header="线路描述(可运、禁运、尺寸要求)">
              <div style={{ whiteSpace: 'pre-line' }}>{route.description}</div>
            </Collapse.Panel>
          </Collapse>
        </div>
      </div>
    </Card>
  );
};

export default React.memo(routeCard);
